/**
 * @file automatically generated from MApp.Endpoints.UserActivationController
 */ 

import { MetadataClient } from '../metadataClient';
import { IStringObject, IValidationResult, IUserInfo, IActivateUser, IGuidObject } from '../models';

export class UserActivationClient extends MetadataClient {

    public static isPasswordValid(password: IStringObject) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/password/validate`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(password)
			}),
			true
        );
    }

    public static getUserInfo(activationId: string) {
        return MetadataClient.ajax<IUserInfo>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/${encodeURIComponent(activationId)}`),
			true
        );
    }

    public static activateUser(activationId: string, activateUser: IActivateUser) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/${encodeURIComponent(activationId)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(activateUser)
			}),
			true
        );
    }

    public static forgotPassword(user: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/${encodeURIComponent(user)}/forgotpassword`),
			true
        );
    }

    public static deactivateUserByActivation(activationId: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/deactivate/${encodeURIComponent(activationId)}`),
			true
        );
    }

    public static deactivateUserById(userId: IGuidObject) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/useractivations/deactivate`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(userId)
			})
        );
    }
}
